import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { usePageViewLogging } from '@/hooks';
import { useIsLoggerUserInfoSet } from '@/lib/auth/UserContext';
export function AnalyticsInitializer() {
  const {
    isReady
  } = useRouter();
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  const hasTrackedQuizInit = useRef(false);
  useEffect(() => {
    if (isReady && isLoggerUserInfoSet && !hasTrackedQuizInit.current) {
      logger.track('quiz_init');
      hasTrackedQuizInit.current = true;
    }
  }, [isReady, isLoggerUserInfoSet]);
  usePageViewLogging();
  return null;
}